import { render } from "./NewsDetails.vue?vue&type=template&id=dc2b6e62&scoped=true"
import script from "./NewsDetails.vue?vue&type=script&lang=js"
export * from "./NewsDetails.vue?vue&type=script&lang=js"

import "./NewsDetails.vue?vue&type=style&index=0&id=dc2b6e62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dc2b6e62"

export default script